const isSuperAdmin = currentUser => currentUser?.type === 'SuperAdmin';

export const canCreateInbox = currentUser => isSuperAdmin(currentUser);
export const canViewInboxHelpLink = currentUser => isSuperAdmin(currentUser);
